import Vue from "vue";
import VueBoostrap from "bootstrap-vue";
import lodash from "lodash";
import VueLodash from "vue-lodash";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import messaging from "./messaging";
import VueApollo from "vue-apollo";
import ApolloClient from "./apollo";
import vClickOutside from "v-click-outside";

// Logging and error tracing
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

import rollbar from './services/rollbar';

import VueGtag from "vue-gtag";
// import VueYandexMetrika from "vue-yandex-metrika"
import Hotjar from "vue-hotjar";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = false;

Vue.use(VueLodash, { name: "custom", lodash: lodash });
Vue.use(VueBoostrap);
Vue.use(VueApollo);

import VueMasonry from "vue-masonry-css";
import "./registerServiceWorker";

Vue.use(VueMasonry);
Vue.use(vClickOutside);

if (process.env.NODE_ENV == "production") {
  Vue.use(
    VueGtag,
    {
      config: { id: "UA-163635930-2" },
    },
    router
  );
  Vue.use(Hotjar, {
    id: "2162942",
  });

  Sentry.init({
    Vue,
    dsn:
      "https://de29ae07d3f54bd1b8fcc279f9900388@o491943.ingest.sentry.io/5558375",
    autoSessionTracking: true,
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
    logErrors: true,
  });

  // Set the Rollbar instance in the Vue prototype
  // before creating the first Vue instance.
  // This ensures it is available in the same way for every
  // instance in your app.
  Vue.prototype.$rollbar = rollbar;
}

// If you have already set up a global error handler,
// just add `vm.$rollbar.error(err)` to the top of it.
// If not, this simple example will preserve the app’s existing
// behavior while also reporting uncaught errors to Rollbar.
Vue.config.errorHandler = (err, vm, info) => {
  vm.$rollbar && vm.$rollbar.error && vm.$rollbar.error(err);
  info;
  throw err; // rethrow
};

const apolloProvider = new VueApollo({
  defaultClient: ApolloClient,
});

if (messaging) {
  messaging.getToken();
}

new Vue({
  el: "#app",
  store,
  router,
  apolloProvider,
  render: (h) => h(App),
}).$mount("#app");
